export const STORAGE_AUTH_TOKEN = 'STORAGE_AUTH_TOKEN';
export const STORAGE_USER = 'STORAGE_USER';
export const STORAGE_PAYMENT_METHOD = 'STORAGE_PAYMENT_METHOD';

export const STORAGE_USER_CONFIRM_TOKEN = 'STORAGE_USER_CONFIRM_TOKEN';
export const STORAGE_USER_CONFIRM_EMAIL = 'STORAGE_USER_CONFIRM_EMAIL';
export const STORAGE_USER_ROLE = 'STORAGE_USER_ROLE';

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const PUBLIC_STRIPE_API_KEY = process.env.REACT_APP_PUBLIC_STRIPE_API_KEY;
// Dev/test builds set REACT_APP_REQUIRE_PAYMENT_METHOD=false so booking works without Stripe.
// Production omits this (or sets true) and still requires a card.
export const REQUIRE_PAYMENT_METHOD = process.env.REACT_APP_REQUIRE_PAYMENT_METHOD !== 'false';